import React from "react";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { 
    TableContainer,
    TableCell,
    Table,
    TableHead,
    TableRow,
    TableBody,
    Paper
 } from "@vapor/react-material";
import Stack from "@vapor/react-material/Stack";
import Box from "@vapor/react-material/Box";
import Divider from "@vapor/react-material/Divider";
import VaporTag from "@vapor/react-custom/VaporTag";
import { useTranslation } from "react-i18next";

export const RischioSummary = ({
    rischioInerenteLivelloS,
    rischioInerenteLivelloC,
    rischioEffettivoLivelloS,
    rischioEffettivoLivelloC,
    livelloAdeguataVerificaS,
    livelloAdeguataVerificaC,
    totRischioInerente,
    totRischioSpecifico,
    totRischioSpecificoPonderato,
    rischioSpecificoLivelloS,
    rischioSpecificoLivelloC,
    totRischioEffettivo,
    currentPrestazione,
    regoleAdeguataVerifica,
    subTotaleA,
    subTotaleB,
    tenantTypeId
}) => {
    const { t } = useTranslation();

    return (
        <>
        {tenantTypeId !== 3 ? 
            <Stack
                direction="column"
                spacing={1}
            >
                <ExtendedTypography
                variant="titleSmall"
                color="primary.main"
                >
                Rischio inerente
                </ExtendedTypography>
                <ExtendedTypography
                variant="subtitle2"
                fontStyle={{ fontWeight: "bold" }}
                >
                {t("valutazione.form.prestazione")}
                </ExtendedTypography>
                <ExtendedTypography variant="subtitle2">
                {currentPrestazione.prestazioneNome}
                </ExtendedTypography>
                <ExtendedTypography
                variant="subtitle2"
                fontStyle={{ fontWeight: "bold" }}
                >
                {t("valutazione.form.regoleCondotta")}
                </ExtendedTypography>
                <ExtendedTypography variant="subtitle2">
                {currentPrestazione.prestazioneRegole === null
                    ? "Non previste"
                    : currentPrestazione.prestazioneRegole}
                </ExtendedTypography>
                <Divider variant="standard" />
                <Stack direction="row" spacing={1}>
                <ExtendedTypography
                    variant="subtitle2"
                    fontStyle={{ fontWeight: "bold" }}
                >
                    {t("valutazione.form.rischioInerente")}
                </ExtendedTypography>
                <Box flexGrow={1} />
                <ExtendedTypography variant="subtitle2">
                    {currentPrestazione.prestazioneRischio.toFixed(2)}
                </ExtendedTypography>
                </Stack>
                <Divider variant="standard" />
                <Stack direction="row" spacing={1}>
                <ExtendedTypography
                    variant="subtitle2"
                    fontStyle={{ fontWeight: "bold" }}
                >
                    {t("valutazione.form.rischioInerente")}{" "}
                    {t("rischio.rischioForm.pond")}{" "}
                    {tenantTypeId === 1 ? "30%" : "40%"}
                </ExtendedTypography>
                <Box flexGrow={1} />
                <ExtendedTypography variant="subtitle2">
                    {totRischioInerente}
                </ExtendedTypography>
                </Stack>
                <VaporTag
                variant="standard"
                label={rischioInerenteLivelloS}
                sx={rischioInerenteLivelloC}
                />
                <Divider variant="standard" />
                <ExtendedTypography
                variant="titleSmall"
                color="primary.main"
                >
                {t("valutazione.form.rischioSpecifico")}
                </ExtendedTypography>
                <Stack direction="row" spacing={1}>
                <ExtendedTypography
                    variant="subtitle2"
                    fontStyle={{ fontWeight: "bold" }}
                >
                    {t("rischio.rischioForm.rskSpecTot")}
                </ExtendedTypography>
                <Box flexGrow={1} />
                <ExtendedTypography variant="subtitle2">
                    {totRischioSpecifico}
                </ExtendedTypography>
                </Stack>
                <Divider variant="standard" />
                <Stack direction="row" spacing={1}>
                <ExtendedTypography
                    variant="subtitle2"
                    fontStyle={{ fontWeight: "bold" }}
                >
                    {t("rischio.rischioForm.rskSpecPond")}{" "}
                    {tenantTypeId === 1 ? "70%" : "60%"}
                </ExtendedTypography>
                <Box flexGrow={1} />
                <ExtendedTypography variant="subtitle2">
                    {totRischioSpecificoPonderato}
                </ExtendedTypography>
                </Stack>
                <VaporTag
                    variant="standard"
                    label={rischioSpecificoLivelloS}
                    sx={rischioSpecificoLivelloC}
                />
                <Divider variant="standard" />
                <ExtendedTypography
                variant="titleSmall"
                color="primary.main"
                >
                {t("dashboard.riskeff")}
                </ExtendedTypography>
                <Stack direction="row" spacing={1}>
                <ExtendedTypography
                    variant="subtitle2"
                    fontStyle={{ fontWeight: "bold" }}
                >
                    {t("valutazione.form.totale")}
                </ExtendedTypography>
                <Box flexGrow={1} />
                <ExtendedTypography variant="subtitle2">
                    {totRischioEffettivo}
                </ExtendedTypography>
                </Stack>
                <VaporTag
                variant="standard"
                label={rischioEffettivoLivelloS}
                sx={rischioEffettivoLivelloC}
                />
                <Divider variant="standard" />
                <ExtendedTypography
                variant="titleSmall"
                color="primary.main"
                >
                {t("valutazione.form.adeguataVerifica")}
                </ExtendedTypography>
                {regoleAdeguataVerifica && (
                    <ExtendedTypography variant="subtitle2">
                        {regoleAdeguataVerifica}
                    </ExtendedTypography>
                )}
                <ExtendedTypography variant="subtitle2">
                    {currentPrestazione.prestazioneRegole}
                </ExtendedTypography>                
                <VaporTag
                    variant="standard"
                    label={livelloAdeguataVerificaS}
                    sx={livelloAdeguataVerificaC}
                />
                <Divider variant="standard" />                
            </Stack> :
            <Stack spacing={2}>
                <TableContainer component={Paper} sx={{ mt: 2 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                            <TableCell align="left" width="70%">
                                <ExtendedTypography
                                variant="subtitle2"
                                fontStyle={{ fontWeight: "bold" }}
                                >
                                Rischio di riciclaggio
                                </ExtendedTypography>
                            </TableCell>
                            <TableCell align="center" width="30%">
                                <ExtendedTypography
                                variant="subtitle2"
                                fontStyle={{ fontWeight: "bold" }}
                                >
                                Punteggio
                                </ExtendedTypography>
                            </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                            <TableCell align="left" width="70%">
                                <ExtendedTypography
                                variant="subtitle2"
                                fontStyle={{ fontWeight: "bold" }}
                                >
                                Totale punteggio A
                                </ExtendedTypography>
                            </TableCell>
                            <TableCell align="center" width="30%">
                                <ExtendedTypography
                                variant="subtitle2"                                        
                                >
                                {subTotaleA}
                                </ExtendedTypography>
                            </TableCell>
                            </TableRow>
                            <TableRow>
                            <TableCell align="left" width="70%">
                                <ExtendedTypography
                                variant="subtitle2"
                                fontStyle={{ fontWeight: "bold" }}
                                >
                                Totale punteggio B
                                </ExtendedTypography>
                            </TableCell>
                            <TableCell align="center" width="30%">
                                <ExtendedTypography
                                variant="subtitle2"                                        
                                >
                                {subTotaleB}
                                </ExtendedTypography>
                            </TableCell>
                            </TableRow>
                            <TableRow>
                            <TableCell align="left" width="70%">
                                <ExtendedTypography
                                variant="subtitle2"
                                fontStyle={{ fontWeight: "bold" }}
                                >
                                Totale complessivo (C)
                                </ExtendedTypography>
                            </TableCell>
                            <TableCell align="center" width="30%">
                                <ExtendedTypography
                                variant="subtitle2"                                        
                                >
                                {subTotaleA+subTotaleB}
                                </ExtendedTypography>
                            </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>  
            </Stack> 
        }
        </>
    )
    
}